import { render, staticRenderFns } from "./assingDriver.vue?vue&type=template&id=52f95468&"
import script from "./assingDriver.vue?vue&type=script&lang=js&"
export * from "./assingDriver.vue?vue&type=script&lang=js&"
import style0 from "./assingDriver.vue?vue&type=style&index=0&id=52f95468&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports